
const Step = {
    LOADING: 'loading',
    ERROR: 'error',
    LOADED: 'loaded'
};

export default Step;
